import classnames from 'classnames';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import InboxIcon from '../icons/inbox_icon';
import ProfileAvatar from '../profile_avatar';

export default class CurrentAssignee extends PureComponent {
  render() {
    const {
      agentName,
      avatarImage,
      className,
      groupName,
      hideAvatarOrIcon,
      isAssigneeCurrentAgent,
      onClick,
      readOnly,
      textLabel,
    } = this.props;
    return (
      <div className={className} onClick={onClick}>
        {hideAvatarOrIcon ? null : renderAvatarOrInboxIcon(groupName, agentName, avatarImage, className)}
        <div className={`${className}-text`}>
          <div className={`${className}-text-label`}>{textLabel}</div>
          <StyledNameWrapper>
            <div className={classnames(`${className}-text-name`, { [`${className}-text-name-readOnly`]: readOnly })}>
              {getAssignee({ agentName, groupName, isAssigneeCurrentAgent })}
            </div>
            {!readOnly && <StyledIcon icon={faChevronDown} />}
          </StyledNameWrapper>
        </div>
      </div>
    );
  }
}

const StyledNameWrapper = styled.div`
  align-items: center;
  display: flex;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${p => p.theme.colors.green400};
  margin-left: 5px;
`;

CurrentAssignee.propTypes = {
  agentName: PropTypes.string,
  avatarImage: PropTypes.string,
  className: PropTypes.string,
  hideAvatarOrIcon: PropTypes.bool,
  isAssigneeCurrentAgent: PropTypes.bool,
  groupName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  textLabel: PropTypes.string,
};

export function getAssignee({ agentName, groupName, isAssigneeCurrentAgent }) {
  if (agentName && agentName.length && groupName && groupName.length) {
    return `${getAgentName(agentName, isAssigneeCurrentAgent)} in ${groupName}`;
  } else if (agentName && agentName.length) {
    return getAgentName(agentName, isAssigneeCurrentAgent);
  } else if (groupName && groupName.length) {
    return groupName;
  }
  return 'Not assigned';
}

export function renderAvatarOrInboxIcon(groupName, agentName, avatarImage, className, wrapperClassName) {
  if (agentName) {
    return <ProfileAvatar profile={{ name: agentName, image: avatarImage }} wrapperClassName={wrapperClassName} />;
  } else if (groupName) {
    return (
      <div className={`${className}-inboxIconContainer`}>
        <InboxIcon className={`${className}-inboxIcon`} />
      </div>
    );
  }
  return <ProfileAvatar profile={{ name: '' }} />;
}

function getAgentName(agentName, isAssigneeCurrentAgent) {
  if (isAssigneeCurrentAgent) {
    return `${agentName} (You)`;
  }
  return agentName;
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/assignment_menu/current_assignee.jsx